// extracted by mini-css-extract-plugin
export default {"resumeBasic":"resumeBasic_resumeBasic__I10eL"};